export const HEADER_VARIANT = 'header';
export const ACCOUNT_VARIANT = 'account';
